import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMutation, useQuery } from '@tanstack/react-query';
var KV_REST_API_URL = process.env.NEXT_PUBLIC_KV_REST_API_URL;
var KV_REST_API_TOKEN = process.env.NEXT_PUBLIC_KV_REST_API_TOKEN;
export var useGetKvDataQuery = function useGetKvDataQuery(key) {
  var staleTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
  var query = useQuery({
    queryKey: ['kv', key],
    queryFn: function queryFn() {
      return fetchKv(key);
    },
    enabled: !!key,
    retry: false,
    staleTime: staleTime
  });
  return {
    kvData: query.data,
    query: query
  };
};
export var usePostKvDataMutation = function usePostKvDataMutation() {
  var mutation = useMutation({
    mutationFn: function mutationFn(params) {
      return postKv(params);
    }
  });
  return {
    mutation: mutation
  };
};

var fetchKv = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
    var response, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("".concat(KV_REST_API_URL, "/get/").concat(key), {
              headers: {
                Authorization: "Bearer ".concat(KV_REST_API_TOKEN)
              }
            });

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();

          case 5:
            data = _context.sent;
            return _context.abrupt("return", _objectSpread(_objectSpread({}, JSON.parse(data.result)), {}, {
              param: key
            }));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchKv(_x) {
    return _ref.apply(this, arguments);
  };
}();

var postKv = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var key, value, type, d;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            key = _ref2.key, value = _ref2.value, type = _ref2.type;
            _context2.next = 3;
            return fetch("".concat(KV_REST_API_URL, "/set/").concat(key), {
              headers: {
                Authorization: "Bearer ".concat(KV_REST_API_TOKEN)
              },
              body: JSON.stringify({
                value: value,
                type: type
              }),
              method: 'POST'
            }).then(function (response) {
              return response.json();
            }).then(function (data) {
              return data;
            });

          case 3:
            d = _context2.sent;
            return _context2.abrupt("return", d);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function postKv(_x2) {
    return _ref3.apply(this, arguments);
  };
}();